import React, { useState } from 'react';
import Checkbox from '../../../../Components/Base/Checkbox/Checkbox';
import { useAppContext } from '../../../../Services/AppContext';
import Loading, { LoadingSize } from '../../../../Components/Loading';
import useElectronicSignature from '../../Hooks/useElectronicSignature';
import useMeta from '../../../Meta/Hooks/useMeta';

const ElectronicSignatureSetup: React.FC = () => {
	const { userData } = useAppContext();
	const { createUserMeta } = useMeta();
	const { isQualifiedCertificateForElectronicSignatureUsed, isLoading } =
		useElectronicSignature();
	const [checked, setChecked] = useState(
		isQualifiedCertificateForElectronicSignatureUsed,
	);

	const handleChange = async (value: boolean) => {
		setChecked(value);
		await createUserMeta(
			userData.id,
			'useQualifiedCertificateForElectronicSignature',
			value,
		);
	};

	if (isLoading) {
		return <Loading size={LoadingSize.SMALL} />;
	}

	return (
		<Checkbox
			tx='component.electronicSignatureSetup.checkbox'
			value={checked}
			onChange={handleChange}
		/>
	);
};

export default ElectronicSignatureSetup;
